import useNotifier from "@saleor/hooks/useNotifier";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import ContactUsPage, { ContactUsFormData } from "../components/ContactUs";
import ContactUsController from "../controllers/ContactUsController";
import { ContactUsEmailMutation } from "../mutations";
import { ContactUsEmail } from "../types/ContactUsEmail";
import Validate from "./../controllers/CustomValidation";
const Contactus: React.FC = () => {
  const notify = useNotifier();
  const intl = useIntl();
  const [validations, setValidation] = useState({
    err: {},
    err_msg: []
  });
  const [userAgree, setAgree] = useState(false);
  const handleToggle = userAgree => {
    setAgree(!userAgree);
  };
  const { user, handleChange, handleReset } = ContactUsController();
  const handleContactUs = (data: ContactUsEmail) => data;
  return (
    <ContactUsEmailMutation onCompleted={handleContactUs}>
      {ContactUsEmail => {
        const handleSubmit = async (data: ContactUsFormData) => {
          if (!userAgree) {
            notify({
              status: "error",
              text: "Please Complete the form before Submitting"
            });
            return false;
          }
          const initValidations = {
            company: { required: true, usename: "Company" },
            concern: { required: true, usename: "Concern" },
            contactNumber: { required: true, usename: "Contact Number" },
            emailAddress: {
              email: true,
              required: true,
              usename: "Email Address"
            },
            fileUpload: { required: false, usename: "Image Upload" },
            fullName: {
              required: true,
              usename: "Fullname"
            },
            mallBranch: { required: true, usename: "Mall Branch" },
            message: { required: true, usename: "Message" }
          };
          const {
            validation_errors,
            validation_has_error,
            validation_message
          } = Validate(initValidations, data);
          if (validation_has_error) {
            const timer = setTimeout(() => {
              //   console.log(validation_errors);
              //   console.log(validation_message);
              setValidation({
                err: validation_errors,
                err_msg: validation_message
              });
              return false;
            }, 1500);
            return () => clearTimeout(timer);
          }
          const contactUs_result = await ContactUsEmail({
            variables: {
              input: {
                company: data.company,
                concern: data.concern,
                contactNumber: data.contactNumber,
                emailAddress: data.emailAddress,
                fileUpload: data.fileUpload,
                fullName: data.fullName,
                mallBranch: data.mallBranch,
                message: data.message
              }
            }
          });
          // console.log(contactUs_result);
          setAgree(false);
          const { status } = contactUs_result.data.contactUsEmail;
          // // console.log(errors);
          if (status === "Success") {
            notify({
              status: "success",
              text: intl.formatMessage({
                defaultMessage: "Message Sent",
                description: "Message Sent"
              })
            });
            setValidation({
              err: {},
              err_msg: []
            });
            handleReset();
          }
        };
        return (
          <ContactUsPage
            handleChange={handleChange}
            handleToggle={handleToggle}
            onSubmit={handleSubmit}
            user={user}
            userAgree={userAgree}
            validations={validations}
          />
        );
      }}
    </ContactUsEmailMutation>
  );
};
Contactus.displayName = "Contactus";
export default Contactus;
